import {Component} from '@angular/core';
import {MatIcon} from "@angular/material/icon";

@Component({
  selector: 'app-access-denied',
    imports: [
        MatIcon
    ],
  templateUrl: './access-denied.component.html',
  styleUrls: ['../main/main.component.scss','./access-denied.component.scss']
})
export class AccessDeniedComponent {

}
